<div class="affiliate-list-container">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany?.name || element.insuranceCompany}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        {{element.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="affiliateLink">
      <th mat-header-cell *matHeaderCellDef> Link afiliacyjny </th>
      <td mat-cell *matCellDef="let element">
        {{element.affiliateLink}}
      </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef> Kod </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.code"
           class="default-link"
           [routerLink]="['/partnerzy/linki-afiliacyjne/szczegoly', element.uuid]">
          {{element.code}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">
          {{element.ofwca?.fullName || ''}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partner/szczegoly', element.partner?.uuid]">
          {{element.partner?.fullName || ''}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="contactDetails">
      <th mat-header-cell *matHeaderCellDef> Dane kontaktowe </th>
      <td mat-cell *matCellDef="let element">
        {{element.firstName}}<br>
        {{element.lastName}}<br>
        {{element.email}}<br>
        {{element.phone}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="concludeDate">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="(userPermissions | async)?.partner.admin_root && element?.status?.key === AFFILIATE_CODE_STATUS_ACTIVE && !element.affiliateLink" [disabled]="!(userPermissions | async)?.partner.admin_root" (click)="delete(element)" mat-icon-button color="warn"><mat-icon>delete</mat-icon> </button>
        <button *ngIf="(userPermissions | async)?.partner.admin_root && element?.status?.key === AFFILIATE_CODE_STATUS_INACTIVE && !element.affiliateLink" [disabled]="!(userPermissions | async)?.partner.admin_root" (click)="restore(element)" mat-icon-button color="accent"><mat-icon>restore_from_trash</mat-icon> </button>
        <button *ngIf="(userPermissions | async)?.partner.admin_root && element.affiliateLink" [disabled]="!(userPermissions | async)?.partner.admin_root" (click)="linkDelete(element)" mat-icon-button color="warn"><mat-icon>delete</mat-icon> </button>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
